import { render, staticRenderFns } from "./AppContentBody.vue?vue&type=template&id=29ec43c3"
import script from "./AppContentBody.vue?vue&type=script&lang=js"
export * from "./AppContentBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports